<template>
  <div class="sp-template">
    <div class="h-title">最新消息</div>
    <el-card class="box-card">
      <!-- 全部消息内容 -->
      <div class="bulletin-content">
        <ul class="list-group">
          <li class="list-group-item" v-for="item in unreadMessageList" :key="item.id">
            <a class="not-read" href="#" @click.prevent="showDetailedBulletion(item)">
              <el-row>
                <el-col :span="2">
                  <div class="year-month">{{item.createDate.substring(0,4)}}</div>
                  <div class="day">{{item.createDate.substring(5,10)}}</div>
                  <div class="year-month">{{item.createDate.substring(10)}}</div>
                </el-col>
                <el-col :span="22">
                  <h4 class="title">
                    <!-- <i v-if="true" class="iconfont icon-New"></i> -->
                    <i class="new-gif__icon"></i>
                    {{item.title}}
                  </h4>
                  <div class="content ql-editor" v-html="item.content"></div>
                </el-col>
              </el-row>
            </a>
          </li>
          <li class="list-group-item" v-for="item in messageList" :key="item.id">
            <a :class="[item.isRead ? 'has-read' : 'not-read']" href="#" @click.prevent="showDetailedBulletion(item)">
              <el-row>
                <el-col :span="2">
                  <div class="year-month">{{item.createDate.substring(0,4)}}</div>
                  <div class="day">{{item.createDate.substring(5,10)}}</div>
                  <div class="year-month">{{item.createDate.substring(10)}}</div>
                </el-col>
                <el-col :span="22">
                  <h4 class="title">
                    <!-- <i v-if="true" class="iconfont icon-New"></i> -->
                    <i v-if="!item.isRead" class="new-gif__icon"></i>
                    {{item.title}}
                  </h4>
                  <div class="content ql-editor" v-html="item.content"></div>
                </el-col>
              </el-row>
            </a>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
      <!-- 最新消息-弹层 -->
      <el-dialog title="最新消息" :visible.sync="dialogBulletinVisible" append-to-body width="30%">
        <div class="dialog-content">
          <span class="title">标题：</span>
          <span class="content">{{checkMessages.title}}</span>
        </div>
        <div class="dialog-content">
          <span class="title">优先级：</span>
          <span class="content">{{checkMessages.level == 1 ? "紧急" : "一般"}}</span>
        </div>
        <div class="dialog-content">
          <span class="title">发布公司：</span>
          <span class="content">{{checkMessages.orgOp}}</span>
        </div>
        <div class="dialog-content">
          <span class="title">发布时间：</span>
          <span class="content">{{checkMessages.createDate}}</span>
        </div>
        <div class="dialog-content">
          <span class="title">内容：</span>
          <span class="content text-content ql-editor" v-html="checkMessages.content"></span>
        </div>
      </el-dialog>
    </el-card>
    <div class="submit-buttons">
      <el-button @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      unreadMessageList: [],
      messageList: [],
      checkMessages: "",
      dialogBulletinVisible: false,
      currentPage: 1, // 当前是第几页
      pageSize: 20, // 每页显示条目个数
      total: 0 // 总条目数
    };
  },
  created() {
    setTimeout(() => {
      this.queryMessage(
        this.currentPage,
        this.pageSize,
        this.$route.query.status
      );
    }, 600);
  },
  methods: {
    showDetailedBulletion(data) {
      this.checkMessages = data;
      this.createdReadNotice(data.id, data.isRead);
      this.dialogBulletinVisible = true;
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.queryMessage(currentPage, this.pageSize, this.$route.query.status);
    },
    handleSizeChange(pageSizes) {
      this.pageSize = pageSizes;
      this.queryMessage(
        this.currentPage,
        this.pageSize,
        this.$route.query.status
      );
    },
    queryMessage(currentPage, pageSize, status) {
      this.$request1({
        method: 'GET',
        url: '/notice/message',
        params: {
          currentPage: currentPage,
          pageSize: pageSize,
          status: status
        }
      })
        .then(response => {
          if(response.data.success){
            this.total = response.data.total;
            this.unreadMessageList = response.data.data.unread;
            this.messageList = response.data.data.all;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    createdReadNotice(noticeId, isRead) {
      if (isRead) {
        return;
      }
      this.$request1({
        method: 'POST',
        url: '/readNotice/create',
        params: {
          noticeId: noticeId
        }
      })
        .then(response => {
          this.queryMessage(
            this.currentPage,
            this.pageSize,
            this.$route.query.status
          );
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.bulletin-content {
  .list-group-item a {
    display: block;
    width: 100%;
    padding: 15px 25px 15px 5px;
    color: #989898;
    border-bottom: 1px solid #e6e6e6;
    .day {
      font-size: 26px;
    }
    .title {
      position: relative;
      margin-bottom: 10px;
      color: #676767;
      .new-gif__icon{
        position: absolute;
        top: 0;
        left: -38px;
      }
    }
    .content {
      width: 100%;
      & :first-child{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      & :not(:first-child){
        display: none;
      }
    }
    &.not-read {
      .day, .year-month, .title {
        color: rgb(34, 34, 34);
      }
      .year-month, .title{
        font-weight: 700;
      }
    }
    &.has-read{
      .day, .year-month, .title{
        color: #989898;
      }
    }
  }
}
.el-pagination {
  margin-top: 50px;
  text-align: left;
}
// .year-month{
//   padding-left: 15px;
// }
</style>


// WEBPACK FOOTER //
// src/views/usercenter/message.vue